/**
 * Optional delivery area: no mandatory modal on product or add-to-cart.
 * First prompt + one geolocation attempt live in skipp-location-modal-entry.js only.
 */

function boot() {
  void 0;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
